import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "error", "invalid", "countryCode", "countryLocale", "value", "onChange"];
import React from 'react';
import PropTypes from 'prop-types';
import { BareInput } from "./BareInput";
import { isPhone } from "../validator";
import { inputTypes } from "../types";

/**
 * A primitive phone input that masks input.
 *
 * @param active
 * @param error
 * @param invalid
 * @param countryCode
 * @param value
 * @param onChange
 * @param rest
 * @returns {*}
 * @constructor
 */
import { jsx as ___EmotionJSX } from "@emotion/core";
function BarePhoneInput(_ref) {
  let {
      // eslint-disable-line,
      // eslint-disable-line
      invalid,
      countryCode,
      value,
      onChange
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const format = typeof window !== 'undefined' && window.i18nUtils.getPhoneFormat();
  const onChangeInput = e => {
    const newFormattedValue = format(e.target.value, countryCode);
    if (newFormattedValue !== false) {
      newFormattedValue.formattedPhoneNumber ? onChange(newFormattedValue.formattedPhoneNumber) : onChange(newFormattedValue);
    }
  };
  return ___EmotionJSX(BareInput, _extends({
    "aria-invalid": invalid
  }, rest, {
    value: typeof format === 'function' && format(value, countryCode).formattedPhoneNumber || value,
    onChange: onChangeInput
  }));
}
BarePhoneInput.validate = isPhone;
BarePhoneInput.inputType = inputTypes.phone;
BarePhoneInput.propTypes = {
  /** Marks if the input should be disabled. */
  disabled: PropTypes.bool,
  /** A unique identifier for the input. */
  id: PropTypes.string.isRequired,
  /** `true` when the input is in error state and has been touched. */
  invalid: PropTypes.bool,
  /** If you need a localized mask you can pass this in. */
  mask: PropTypes.array,
  /** Input name */
  name: PropTypes.string.isRequired,
  /** Handler for when the input blurs. */
  onBlur: PropTypes.func.isRequired,
  /** Handler for when the input value changes . */
  onChange: PropTypes.func.isRequired,
  /** Handler for when the input focuses. */
  onFocus: PropTypes.func.isRequired,
  /** Input placeholder. */
  placeholder: PropTypes.string,
  /** Marks if the input is required for validation purposes. */
  required: PropTypes.bool,
  /** Value of input. */
  value: PropTypes.string
};
export { BarePhoneInput };